<template>
    <div>
        <a-alert :show-icon="true" style="margin-top: 25px;" type="warning">
            <template #message>
                <div>* 拍摄人员属性仅对新上传文件生效，对判定跳过或者覆盖的文件无效</div>
            </template>
        </a-alert>
        <a-alert :show-icon="true" style="margin-top: 15px;" type="warning">
            <template #message>
                <div>
                    <b>1.</b> 文件三要素：文件名称，文件大小，修改时间
                </div>
                <div>
                    <b>2.</b> 系统会根据三要素自动识别并跳过已上传文件
                </div>
                <div>
                    <b>3.</b> 仅支持上传图片和RAW格式数据，其他自动忽略
                </div>
                <div>
                    <b>4.</b> 若通过下载后需再上传覆盖的，则请勿变更文件名
                </div>
                <div>
                    <b>5.</b> 每个图片有三种类型【高清图，RAW格式，原始图】。RAW格式通过后缀自动识别。默认上传的是根据
                    <router-link :to="{name: 'Album.Config.FlowPolicy', params: {id: albumId}}" target="_blank">相册配置</router-link>
                    进行处理后的高清图。若要上传原始图，请勾选上传原图。
                </div>
                <div v-if="!electron">
                    <b>6.</b>
                    老版本浏览器可能不支持选择文件夹上传，上传量大的情况下建议使用
                    <a @click="download">桌面客户端</a>
                    进行上传会有更优的体验
                </div>
            </template>
        </a-alert>
        <UseElectron ref="useElectron"/>
    </div>
</template>

<script>
    import func from "../../../../../utils/func";
    import UseElectron from "../../../../../comps/UseElectron";

    export default {
        name: "UploadAlert",
        components: {UseElectron},
        props: {
            albumId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                electron: func.boolStrict(window.IS_ELECTRON)
            }
        },
        methods: {
            download() {
                this.$refs.useElectron.open(true);
            },
        }
    }
</script>

<style scoped>

</style>
